import React, { useState, useEffect, useRef } from "react";
import 'react-nice-dates/build/style.css'
import "../../../RdssForms/rdssforms.scss";
import { GrDownload, GrUpload } from "react-icons/gr";

// Images
import FieldComponent from "../../../FieldComponent";
import MyTooltip from "./MyTooltip";

const Pq3 = (props: any) => {
    const [fields, setFields] = useState<any[]>([]);
    useEffect(() => {
        setFields(props.fields)
    }, [props.fields]);
    const [roleid, setRoleid] = useState<any>(0);
    useEffect(() => {
        setRoleid(sessionStorage.getItem('roleid'))
    }, [roleid]);

    const [year, setYear] = useState<any>(props.year);

    useEffect(() => {
        setYear(props.year);
    }, [props.year]);

    return (
        <>
        {/* PQ-3 */}
        {fields.length ?
            <>
            <tr>
                <td colSpan={5}></td>
            </tr>
            <tr>
                <td colSpan={5} className="blankPara">
                    <div className="d-flex justify-content-between align-item-center">
                        <div className="d-flex align-items-center w-100">
                            <p className="mb-0 ps-2 fw-medium pe-3">PQ-3 : New regulatory asset created in current tariff determination cycle <b>*</b></p>
                            {roleid == 5 || roleid == 6 || props.iscompletedsubmittedstatus == 1 ?
                                <>
                                {props.submittedStatus == 1 ?
                                    <>
                                    <select defaultValue={fields[215] && fields[215].value ? fields[215].value : ''} name="formdata[pqsop_details][pq3_nodal]" id="pqsop_details_pq3_nodal" className="form-select text-start">
                                        <option value="">Select</option>
                                        <option value="Compliant">Compliant</option>
                                        <option value="Partial Compliant">Partial Compliant</option>
                                        <option value="Non-Compliant">Non-Compliant</option>
                                        <option value="Compliant with Delay">Compliant with Delay</option>
                                    </select>

                                    <div className="col-md-0">
                                        {/* <p className="mb-0 ps-2 fw-medium pe-3">Remarks</p> */}
                                        <div className="form-group text">
                                            <div className="form-field">
                                                <input autoComplete="off" className="form-control" type="text" name="formdata[pqsop_details][pq3_remarks_nodal]" id="pqsop_details_pq3_remarks_nodal" defaultValue={fields[230] && fields[230].value ? fields[230].value : ''} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="fileUpload position-relative text-center">
                                        <div className="dowupEqule">
                                            <input type="file" autoComplete="off" className="form-control" name="formdata[pqsop_details][pq3_document_nodal]" id="pqsop_details_pq3_document_nodal" />
                                            <div className="customUpload justify-content-center flex-wrap">
                                                <span> <GrUpload /> </span>
                                                {/* <span>.PDF, .Docx, .XLS</span> */}
                                            </div>
                                        </div>
                                        {fields[245].value != '' ?
                                            <a href={fields[245].value} title={fields[245].value} className="viewupload" target="_blank"><GrDownload /></a>
                                            : null
                                        }
                                    </div>

                                    </>
                                    :
                                    <>

                                    {fields[215].value != '' ?
                                        <div className="col-md-0">
                                            <div className="form-group select">
                                                <div className="form-field">
                                                    <div className="view-field text-start">
                                                        {fields[215] && fields[215].value ? fields[215].value : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                    }

                                    {/* { fields[230].value != '' ? */}
                                    <div className={"view-field text-start"}> {fields[230] && fields[230].value ? fields[230].value : ''}</div>
                                    {/* : null
                                        } */}

                                    {fields[245].value != '' ?
                                        <div className="view-field text-center">
                                            <a href={fields[245] && fields[245].value ? fields[245].value : ''} title={fields[245] && fields[245].value ? fields[245].value : ''} className="viewupload" target="_blank">
                                                <span><GrDownload /></span>
                                            </a>
                                        </div>
                                        : null
                                    }

                                    </>

                                }
                                </> : null
                            }

                        </div>
                        <div className={props.remove}>
                            <MyTooltip placement="left">
                                <ul>
                                    <li>DISCOMs will have ensured that no new Regulatory Assets have been created in latest tariff determination cycle</li>
                                    <li>Documentary Evidence: Copy of latest Tariff Order</li>
                                </ul>
                            </MyTooltip>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    Projected ARR for FY ({(year * 1) + 1}) in Petition filed by DISCOM to SERC/JERC (INR Cr)
                      </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[38].key} field={fields[38]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[39].key} field={fields[39]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>ARR approved by SERC/JERC for FY ({(year * 1) + 1}) (INR Cr)</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[40].key} field={fields[40]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[41].key} field={fields[41]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>Projected Revenue with Tariff approved by SERC/JERC</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[258].key} field={fields[258]} />
                </td>
                <td>
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>Revenue Gap, if any</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[259].key} field={fields[259]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[260].key} field={fields[260]} />
                </td>
                <td>%</td>
                <td></td>
            </tr>
            <tr>
                <td>Status</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[42].key} field={fields[42]} />
                </td>
            </tr>
            <tr className="borderThik">
                <td>Remarks</td>
                <td colSpan={4}>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[43].key} field={fields[43]} />
                </td>
            </tr>
            </>
            : null
        }
        </>
    );
};

export default Pq3;